export const gaEventNameEnum = {
    SIGNUP_VERIFY_OTP: 'verifyOtpSignup',
    LOGIN_VERIFY_OTP: 'verifyOtplogin',
    ACCEPT_IFA_INVITE: 'acceptIfaInvite',
    WEBINAR_PAGE_VIEWED: 'webinarPageViewed',
    WEBINAR_VIDEO_CLICKED: 'webinarVideoClicked',
    WEBINAR_LINK_CLICKED: 'webinarLinkClicked',
    CLICKED_LIST_VIEW_OPPORTUNITIES_MOBILE: 'clickedListViewOpportunitiesMobileWeb',
    CLICKED_INVEST_NOW: 'clickedInvestNow',
    ACCEPT_FUND_DECLARATION: 'acceptFundDeclaration',
    ACCEPT_DISCLAIMER: 'acceptDisclaimer',
    CONFIRM_INVESTMENT_DETAILS: 'confirmInvestmentDetails',
    VERIFY_DEMAT_DETAIL: 'verifyDematDetails',
    SUBMIT_DEMAT_DETAILS: 'submitDematDetails',
    ACCEPT_LLP_AGREEMENT: 'acceptLlpAgreement',
    DOWNLOAD_LLP_AGREEMENT: 'downloadLlpAgreement',
    SUBMIT_PROFILE_DETAILS: 'submitProfileDetails',
    ACCEPT_DISCOUNTING_AGREEMENT: 'acceptDiscountingAgreement',
    DOWNLOAD_DISCOUNTING_AGREEMENT: 'downloadDiscountingAgreement',
    VIEWED_ESIGN_PAGE: 'viewedEsignPage',
    SUCCESSFULLY_SIGNED_DOCUMENT: 'successfullySignedDocument',
    CANCELLED_SIGNED_DOCUMENT: 'cancelledSignedDocument',
    ERROR_SIGNED_DOCUMENT: 'errorSignedDocument',
    VIEWED_ONBOARDING_ESIGN_PAGE: 'viewedOnboardingEsignPage',
    SUCCESSFULLY_SIGNED_ONBOARDING_DOCUMENT: 'successfullySignedOnboardingDocument',
    CANCELLED_SIGNED_ONBOARDING_DOCUMENT: 'cancelledSignedOnboardingDocument',
    ERROR_SIGNED_ONBOARDING_DOCUMENT: 'errorSignedOnboardingDocument',
    VIEWED_PAYMENT_PAGE: 'viewedPaymentPage',
    PROCEED_WITH_ALTSAFE: 'proceedWithAltsafe',
    PROCEED_WITH_PG: 'proceedWithPg',
    PROCEED_WITH_UPI: 'proceedWithUpi',
    PROCEED_WITH_NETBANKING_FREECHANGE: 'proceedWithNetBankingFreecharge',
    PROCEED_WITH_NETBANKING_PAYU: 'proceedWithNetBankingPayu',
    EXIT_TRANSACTION: 'exitTransaction',
    VIEWED_INVESTMENT_SUCCESS_PAGE: 'viewedInvestmentSuccessPage',
    VIEWED_PENDING_PAYMENT_PAGE: 'viewedPendingPaymentPage',
    VIEWED_INVESTMENT_FAILED_PAGE: 'viewedInvestmentFailedPage',
    CLICKED_RETRY_PAYMENT: 'clickedRetryPayment',
    CLICKED_UPDATE_PREFERENCE_INVESTMENT_PAGE: 'clickedUpdatePreferenceInvestmentPage',
    UPCOMING_WEBINAR_PAGE_VIEWED: 'upcomingWebinarPageViewed',
    UPCOMING_WEBINAR_PAGE_CLICKED: 'upcomingWebinarClicked',
    VIEWED_QUESTIONNAIRE_PAGE: 'viewedQuestionnairePage',
    CLICKED_QUESTIONNAIRE_CONTINUE: 'clickQuestionnaireContinue',
    CLICKED_QUESTIONNAIRE_SKIP: 'clickQuestionnaireSkip',
    VIEWED_WELCOME_PAGE: 'viewedWelcomePage',
    CLICKED_BOOK_CONSULTATION_WELCOME_PAGE: 'clickBookConsultationWelcomePage',
    CLICKED_START_KYC_WELCOME_PAGE: 'clickStartKYCWelcomePage',
    CLICKED_SKIP_WELCOME_PAGE: 'clickSkipWelcomePage',
    VIEWED_WELCOME_BACK_PAGE: 'viewedWelcomeBackPage',
    CLICKED_BOOK_CONSULTATION_WELCOME_BACK_PAGE: 'clickBookConsultationWelcomeBackPage',
    CLICKED_START_KYC_WELCOME_BACK_PAGE: 'clickStartKYCWelcomeBackPage',
    CLICKED_COMPLETE_KYC_WELCOME_BACK_PAGE: 'clickCompleteKYCWelcomeBackPage',
    CLICKED_SKIP_WELCOME_BACK_PAGE: 'clickSkipWelcomeBackPage',
    CLICKED_CHAT_WITH_RM_MOBILE_WEB_NAVIGATION: 'clickedChatWithRmMobileWebNavigation',
    CLICKED_CHAT_WITH_RM_SIDENAV_MOBILE_WEB_NAVIGATION: 'clickedChatWithRmSideNavMobileWebNavigation',
    CLICKED_INVESTOR_INITIAL_MOBILE_WEB_NAVIGATION: 'clickedInvestorInitialMobileWebNavigation',
    CLICKED_HOME_PAGE_MORE_MOBILE_WEB_NAVIGATION: "clickedHomePageMoreMobileWebNavigation",
    CLICKED_RM_SIDENAV_MOBILE_WEB_NAVIGATION: "clickedRelationshipManagerSideNavMobileWebNavigation",
    CLICKED_REFER_AND_EARN_SIDENAV_MOBILE_WEB_NAVIGATION: "clickedReferandEarnSideNavMobileWebNavigation",
    CLICKED_ABOUT_US_SIDENAV_MOBILE_WEB_NAVIGATION: "clickedAboutUsSideNavMobileWebNavigation",
    CLICKED_CAREERS_SIDENAV_MOBILE_WEB_NAVIGATION: "clickedCareersSideNavMobileWebNavigation",
    CLICKED_CONTACT_US_SIDENAV_MOBILE_WEB_NAVIGATION: "clickedContactUsSideNavMobileWebNavigation",
    CLICKED_FAQS_SIDENAV_MOBILE_WEB_NAVIGATION: "clickedFaqsSideNavMobileWebNavigation",
    CLICKED_WEBINARS_SIDENAV_MOBILE_WEB_NAVIGATION: "clickedWebinarsSideNavMobileWebNavigation",
    CLICKED_BLOGS_SIDENAV_MOBILE_WEB_NAVIGATION: "clickedBlogsSideNavMobileWebNavigation",
    CLICKED_CREDIT_EVALUATION_PROCESS_SIDENAV_MOBILE_WEB_NAVIGATION: "clickedCreditEvaluationSideNavMobileWebNavigation",
    CLICKED_ABL_SIDENAV_MOBILE_WEB_NAVIGATION: "clickedABLSideNavMobileWebNavigation",
    CLICKED_FD_SIDENAV_MOBILE_WEB_NAVIGATION: "clicked_fd_sidenav_mobile_web_navigation",
    CLICKED_ID_SIDENAV_MOBILE_WEB_NAVIGATION: "clickedIDSideNavMobileWebNavigation",
    CLICKED_VD_SIDENAV_MOBILE_WEB_NAVIGATION: "clickedVentureDeptSideNavMobileWebNavigation",
    CLICKED_CD_SIDENAV_MOBILE_WEB_NAVIGATION: "clickedCorporateDeptSideNavMobileWebNavigation",
    CLICKED_PRODUCTS_SIDENAV_MOBILE_WEB_NAVIGATION: "clickedProductsSideNavMobileWebNavigation",
    CLICKED_KNOWLEDGE_CENTER_SIDENAV_MOBILE_WEB_NAVIGATION: "clickedKnowledgeCenterSideNavMobileWebNavigation",
    CLICKED_OUR_COMPANY_SIDENAV_MOBILE_WEB_NAVIGATION: "clickedOurCompanySideNavMobileWebNavigation",
    CLICKED_THE_JOURNEY_SIDENAV_MOBILE_WEB_NAVIGATION: "clickedTheJourneySideNavMobileWebNavigation",
    CLICKED_VALUES_SIDENAV_MOBILE_WEB_NAVIGATION: "clickedValuesSideNavMobileWebNavigation",
    CLICKED_INVESTORS_SIDENAV_MOBILE_WEB_NAVIGATION: "clickedInvestorsSideNavMobileWebNavigation",
    CLICKED_LOGOUT_SIDENAV_MOBILE_WEB_NAVIGATION: "clickedLogoutSideNavMobileWebNavigation",
    SUBMIT_BANK_DETAILS: "submitBankDeatils",
    VISITED_SIGNUP_PAGE: "visitedSignupPage",
    CLICKED_OPPORTUNITY_WITH_REINVEST_TAG: 'clickedOpportunityWithReinvestTag',
    INVESTMENT_FLOW_AUTO_REINVEST_ENABLED: 'investmentFlowAutoReinvestEnabled',
    INVESTMENT_FLOW_AUTO_REINVEST_SKIPPED: 'investmentFlowAutoReinvestSkipped',
    AUTO_REINVEST_TURN_ON: 'autoReinvestTurnOn',
    PAYMENT_SUCCESS_AUTO_REINVEST_ENABLED: 'paymentSuccessAutoReinvestEnabled',
    PAYMENT_SUCCESS_AUTO_REINVEST_SKIPPED: 'paymentSuccessAutoReinvestSkipped',
    REINVESTMENT_DETAILS_MODIFY_PREFERENCE: 'reinvestmentDetailsModifyPreference',
    REINVESTMENT_DETAILS_TURN_ON: 'reinvestmentDetailsTurnOn',
    REINVESTMENT_DETAILS_MODIFY_CONFIRM: 'reinvestmentDetailsModifyConfirm',
    REINVESTMENT_DETAILS_TURN_ON_CONFIRM: 'reinvestmentDetailsTurnOnConfirm',
    REINVESTMENT_DETAILS_MODIFY_CANCEL: 'reinvestmentDetailsModifyCancel',
    REINVESTMENT_DETAILS_TURN_ON_CANCEL: 'reinvestmentDetailsTurnOnCancel',
    REINVESTMENT_DETAILS_CARD_CLICK: 'reinvestmentDetailsCardClick',
    REINVESTMENT_DASHBOARD_CARD_CLICK: 'reinvestmentDashboardCardClick',
    DASHBOARD_REINVESTMENT_BANNER: 'dashboardReinvestmentBanner',
    INVESTMENT_DETAILS_VIEW_REINVEST_DETAILS: 'investmentDetailsViewReinvestDetails',
    OPPORTUNITY_LISTING_REINVESTMENT_BANNER: 'opportunityListingReinvestmentBanner',
    VIEW_REINVESTMENT_DASHBOARD: 'viewReinvestmentDashboard',
    VIEW_REINVESTMENT_DETAILS: 'viewReinvestmentDetails',
    VIEW_INVESTMENT_DETAILS: 'viewInvestmentDetails',
    VIEW_INVESTMENT_LIST: 'viewInvestmentList',
    CLICKED_APP_DOWNLOAD_NUDGE: 'clickedAppDownloadNudge',
    CANCELLED_APP_DOWNLOAD_NUDGE: 'cancelledAppDownloadNudge',
    CLICKED_START_KYC: "clickedStartKyc",
    CLICKED_CONTINUE_AS_INDIVIDUAL: "clickedContinueAsIndividual",
    CLICKED_CONTINUE_AS_NRI: "clickedContinueAsNri",
    CLICKED_CONFIRM_PAN: "clickedConfirmPan",
    CLICKED_PROCEED_WITH_DIGILOCKER: "clickedProceedWithDigilocker",
    CLICKED_PROCEED_WITH_DOCUMENT_UPLOAD: "clickedProceedWithDocumentUpload",
    SUCCESSFULLY_FETCHED_AADHAR_DETAILS_DIGILOCKER: "successfullyFetchedAdharDetailsDigilocker",
    CLICKED_PROCEED_WITH_DOCUMENT_UPLOAD_OUTSIDE_INDIA: "clickedProceedWithDocumentUploadOutsideIndia",
    CLICKED_PROCEED_WITH_DOCUMENT_UPLOAD_NO_CONNECT_DIGILOCKER: "clickedProceedWithDocumentUploadNoConnectDigilocker",
    CLICKED_PROCEED_WITH_DOCUMENT_UPLOAD_NO_RESPONSE: "clickedProceedWithDocumentUploadNoResponse",
    CLICKED_SWITCH_TO_DIGILOCKER: "clickedSwitchToDigilocker",
    CLICKED_CONTINUE_SELECT_DOC_TYPE: "clickedContinueSelectDocType",
    CLICKED_CHANGE_DOC_TYPE: "clickedChangeDocType",
    CLICKED_TO_UPLOAD_ADDRESS_DOCUMENT: "clickedToUploadAddressDocument",
    CLICKED_REUPLOAD_ADDRESS_DOCUMENT: "clickedReuploadAddressDocument",
    CLICKED_CONTINUE_DOC_SUBMIT: "clickedContinueDocSubmit",
    CLICKED_ADD_BANK_ACCOUNT_HV: "clickedAddBankAccountHV",
    CLICKED_CONTINUE_HV: "clickedContinueHv",
    CLICKED_CHANGE_ACCOUNT_HV: "clickedChangeAccountHv",
    CLICKED_RETRY_HV: "clickedRetryHv",
    CLICKED_CANCEL_HV: "clickedCancelHv",
    CLICKED_BANK_DETAILS_HV_OUTSIDE_INDIA: "clickedBankDetailsHvOutsideIndia",
    CLICKED_BANK_DETAILS_HV_NOT_WORKING: "clickedBankDetailsHvNotWorking",
    CLICKED_BANK_DETAILS_HV_MAX_RETRY: "clickedBankDetailsHvMaxRetry",
    CLICKED_YES_EXIT_HV: "clickedYesExitHv",
    CLICKED_NO_CONTINUE_HV: "clickedNoContinueHv",
    CLICKED_SKIP_DEMAT: "clickedSkipDemat",
    CLICKED_CONTINUE_DEMAT: "clickedContinueDemat",
    VIEWED_KYC_VERIFIED_PAGE: "kycVerified",
    VIEWED_MANUAL_VERIFICATION_PAGE: "kycManualVerification",
    CLICKED_BOOK_CONSULTATION_VERIFIED: "clickedBookConsultationVerified",
    CLICKED_EXPLORE_OPP_VERIFIED: "clickedExploreOppVerified",
    CLICKED_EXPLORE_OPP_MANUAL: "clickedExploreOppManual",
    CLICKED_BOOK_CONSULTATION_MANUAL: "clickedBookConsultationManual",
    CLICKED_REINVESTMENT_DOC_SIGN_E_SIGN_NOW: 'clicked_reinv_doc_sign_e_sign_now',
    CLICKED_REINVESTMENT_DOC_SIGN_RETRY_E_SIGN: 'clicked_reinv_doc_sign_retry_e_sign',
    CLICKED_REINVESTMENT_DOC_SIGN_ALREADY_SIGN_GO: 'clicked_reinv_doc_sign_already_sign_go',
    CLICKED_REINVESTMENT_DOC_SIGN_EXPIRED_GO: 'clicked_reinv_doc_sign_expired_go',
    CLICKED_REINVESTMENT_DOC_SIGN_LOGOUT_OK: 'clicked_reinv_doc_sign_logout_ok',
    CLICKED_REINVESTMENT_DOC_SIGN_SUCCESS_DETAILS: 'clicked_reinv_doc_sign_success_details',
    CLICKED_REINVESTMENT_DOC_SIGN_DOWNLOAD_DOCUMENT: 'clicked_reinv_doc_sign_download_doc',
    CLICKED_REINVESTMENT_DOC_SIGN_SUCCESS_EXPLORE_OPP: 'clicked_reinv_doc_sign_succ_explore_opp',
    CLICKED_REINVESTMENT_DOC_SIGN_PROGRESS_EXPLORE_OPP: 'clicked_reinv_doc_sign_prog_explore_opp',
    CLICKED_REINVESTMENT_DETAILS_E_SIGN_NOW: 'clicked_reinv_details_e_sign_now',
    CLICKED_OPP_REINVESTMENT_E_SIGN_NOW: 'clicked_opp_reinv_e_sign_now',
    CLICKED_MY_INV_DETAILS_REINVESTMENT_E_SIGN_NOW: 'clicked_my_inv_details_reinv_e_sign_now',
    CLICKED_PROFILE_EDIT_NUMBER: "clickedProfileEditNumber",
    CLICKED_PROFILE_EDIT_EMAIL: "clickedProfileEditEmail",
    CLICKED_PROFILE_CHAT_WITH_RM: "clickedProfileChatWithRm",
    CLICKED_PROFILE_BOOK_CONSULTATION: "clickedProfileBookConsultation",
    CLICKED_PROFILE_COMPLETE_KYC: "clickedProfileCompleteKyc",
    CLICKED_PROFILE_ADD_DEMAT: "clickedProfileAddDemat",
    CLICKED_PROFILE_ADD_NOMINEE: "clickedProfileAddNominee",
    CLICKED_NEWS_LETTERS_SIDENAV_MOBILE_WEB_NAVIGATION: "clicked_news_letters_sidenav_mobile_web_navigation",
    CLICKED_NEWS_LETTERS_LINK: 'clicked_news_letters_link',
    VIEWED_NEWS_LETTERS_PAGE: "viewed_news_letters_page",
    CLICKED_NEWS_LETTERS_READ_NOW: "clicked_news_letters_read_now",
    SIGNUP_FORM_START: "signup_form_start"
};

export const taxOptimiserEvents = {
    PAGE_VIEW_LANDING_PAGE_TAX_OPTIMISER: "page_view_landing_page_tax_optimiser",
    VERIFY_OTP_TAX_OPTIMISER: "verify_otp_tax_optimiser",
    GO_TO_ALTGRAAF_NOT_ELIGIBLE_TAX_OPTIMISER: "go_to_altgraaf_not_eligible_tax_optimiser",
    SET_UP_FREE_CONSULTATION_TAX_OPTIMISER: "set_up_free_consultation_tax_optimiser",
    START_TAX_OPTIMISER: "start_tax_optimiser",
    BACK_ON_START_TAX_OPTIMISER: "back_on_start_tax_optimiser",
    SALARIED_BUSINESS_OPTION_TAX_OPTIMISER: "salaried_business_option_tax_optimiser",
    OLD_NEW_REGIME_OPTION_TAX_OPTIMISER: "old_new_regime_option_tax_optimiser",
    TAX_SAVVY_OPTION_TAX_OPTIMISER: "tax_savvy_option_tax_optimiser",
    TAX_BRACKET_OPTION_TAX_OPTIMISER: "tax_bracket_option_tax_optimiser",
    CA_OPTION_TAX_OPTIMISER: "ca_option_tax_optimiser",
    SUBMIT_QUESTIONNAIRE_TAX_OPTIMISER: "submit_questionnaire_tax_optimiser",
    SKIPPED_CALENDAR_BOOKING_TAX_OPTIMISER: "skipped_calendar_booking_tax_optimiser",
    CALENDAR_BOOKED_SUCCESS_TAX_OPTIMISER: "calendar_booked_success_tax_optimiser",
    JOIN_MEETING_CALL1_TAX_OPTIMISER: "join_meeting_call1_tax_optimiser",
    GO_TO_ALTGRAAF_DASHBOARD_TAX_OPTIMISER: "go_to_altgraaf_dashboard_tax_optimiser",
    CLICKED_TAX_OPTIMISER_OPPORTUNITY_LISTING: "clicked_tax_optimiser_opportunity_listing",
    CLICKED_TAX_OPTIMISER_WEB_DASHBOARD: "clicked_tax_optimiser_web_dashboard",
    LOGOUT_TAX_OPTIMISER: "logout_tax_optimiser",
    SEE_SCORE_CARD_TAX_OPTIMISER: "see_score_card_tax_optimiser",
    JOIN_MEETING_CALL2_TAX_OPTIMISER: "join_meeting_call2_tax_optimiser"
};

export const taxOptimiserV2Events = {
    TO_FORM_START: "to_form_start",
    TO_OTP_VERIFIED_SIGNUP: "to_otp_verified_signup",
    TO_OTP_VERIFIED_LOGIN: "to_otp_verified_login",
    TO_START_QUESTIONNAIRE: "to_start_questionnaire",
    TO_QUESTIONNAIRE_BASIC_PROFILE: "to_questionnaire_basic_profile",
    TO_QUESTIONNAIRE_PERSONAL_PROFILE: "to_questionnaire_personal_profile",
    TO_QUESTIONNAIRE_FINANCE_PROFILE: "to_questionnaire_finance_profile",
    TO_QUESTIONNAIRE_INVESTMENT_PROFILE: "to_questionnaire_investment_profile",
    TO_QUESTIONNAIRE_OTHER_INVESTMENT: "to_questionnaire_other_investment",
    TO_CLICKED_VIEW_STRATEGIES: "to_clicked_view_strategies",
    TO_CLICKED_UNLOCK_STRATEGY: "to_clicked_unlock_strategy",
    TO_CLICKED_VIEW_PLANS: "to_clicked_view_plans",
    TO_UNLOCK_NOW_ONLY_STRATEGY: "to_unlock_now_only_strategy",
    TO_UNLOCK_NOW_BUNDLE_PLAN: "to_unlock_now_bundle_plan",
    TO_PAYMENT_START_ONLY_STRATEGY: "to_payment_start_only_strategy",
    TO_PAYMENT_START_BUNDLE_PLAN: "to_payment_start_bundle_plan",
    TO_DOWNLOAD_QUESTIONS_PDF: "to_download_questions_pdf",
    TO_DOWNLOAD_STRATEGIES_PDF: "to_download_strategies_pdf",
    TO_UNLOCK_NOW_CONSULTATION: "to_unlock_now_consultation",
    TO_PAYMENT_START_CONSULTATION: "to_payment_start_consultation",
    TO_SCHEDULE_CALL: "to_schedule_call",
    TO_RESCHEDULE_CALL: "to_reschedule_call",
    TO_JOIN_MEETING: "to_join_meeting",
    TO_VIEWED_WAITING_SCREEN: "to_viewed_waiting_screen",
    TO_VIEWED_STRATEGY_SUMMARY: "to_viewed_strategy_summary",
    TO_VIEWED_ERROR_SCREEN: "to_viewed_error_screen",
    TO_VIEWED_STRATEGIES_SCREEN: "to_viewed_strategies_screen",
    TO_VIEWED_PAYMENT_SUCCESS_SCREEN: "to_viewed_payment_success_screen",
    TO_VIEWED_PAYMENT_SUCCESS_ONLY_STRATEGY: "to_viewed_payment_success_only_strategy",
    TO_VIEWED_PAYMENT_SUCCESS_BUNDLE_PLAN: "to_viewed_payment_success_bundle_plan",
    TO_VIEWED_PAYMENT_SUCCESS_CONSULTATION: "to_viewed_payment_success_consultation",
    TO_VIEWED_PAYMENT_FAILED_SCREEN: "to_viewed_payment_failed_screen",
    TO_VIEWED_PAYMENT_PENDING_SCREEN: "to_viewed_payment_pending_screen",
};

export const fdProductEvents = {
    VIEWED_FD_PRODUCT_PAGE: 'viewed_fd_product_page',
    CLICKED_FD_PRODUCT_BOOK_NOW: 'clicked_fd_product_book_now',
    CLICKED_FD_OPPORTUNITY_LISTING_BOOK_NOW:
        'clicked_fd_opportunity_listing_book_now',
    CLICKED_BOOK_FD_INTERSTITIAL_NUDGE: 'clicked_book_fd_interstitial_nudge',
    CLICKED_SKIP_FD_INTERSTITIAL_NUDGE: 'clicked_skip_fd_interstitial_nudge',
};

export const taxHarvesterEvents = {
    VIEWED_TAX_HARVESTER_DASHBOARD: "viewed_th_dashboard_page",
    CLICK_UNLOCK_NOW_BUTTON_CTA_TAX_HARVESTER_DASHBOARD: "clicked_unlock_now_th_dashboard",
    VIEWED_TAX_HARVESTER_PG_PAGE: "viewed_th_pg_page",
    CLICK_CONTINUE_TO_UPI_PAYMENT_TAX_HARVESTER_PG: "clicked_continue_to_upi_th_pg",
    VIEWED_PAYMENT_SUCCESS_PAGE_TAX_HARVESTER_PG: "viewed_payment_success_page_th_pg",
    VIEWED_PAYMENT_PENDING_PAGE_TAX_HARVESTER_PG: "viewed_payment_pending_page_th_pg",
    VIEWED_PAYMENT_FAILED_PAGE_TAX_HARVESTER_PG: "viewed_payment_failed_page_th_pg",
    VIEW_DOCUMENT_UPLOAD_TAX_HARVESTER_PAGE: "viewed_document_upload_th_page",
    VIEW_TAX_HARVESTER_LANDING_PAGE: "viewed_th_landing_page",
    CLICKED_GET_STARTED_TAX_HARVESTER_LANDING_PAGE: "clicked_get_started_th_landing_page",
    VIEW_TAX_INSIGHTS_PAGE: "viewed_tax_insights_page",
    CLICKED_GO_TO_TAX_HARVESTER_ON_TAX_INSIGHTS_PAGE: "clicked_go_to_th_on_tax_insights_page",
    CLICKED_SUBMIT_TAX_HARVESTER_DOCUMENT_UPLOAD_PAGE: "clicked_submit_th_document_upload_page",
    VIEWED_TAX_HARVESTER_INTRO_PAGE: "viewed_th_intro_page",
    CLICKED_SAVE_TAXES_TAX_HARVESTER_INTRO_PAGE: "clicked_save_taxes_th_intro_page",
    CLICKED_SKIP_TAX_HARVESTER_INTRO_PAGE: "clicked_skip_th_intro_page",
}
